import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details"]

  toggle(event) {
    const isChecked = event.target.checked
    if (this.hasDetailsTarget) {
      this.detailsTarget.style.display = isChecked ? "block" : "none"
    }
  }
}
